import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Container, Alert } from '@mui/material';
import { ResetPasswordForm } from '../../components/features/auth';
import { authService } from '../../services';
import type { ResetPasswordRequest } from '../../types';

export function ResetPasswordPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (data: Omit<ResetPasswordRequest, 'token'>) => {
    if (!token) return;

    setIsLoading(true);
    setError(null);
    try {
      await authService.resetPassword({
        token,
        ...data,
      });
      navigate('/login', {
        state: { message: '비밀번호가 성공적으로 변경되었습니다. 새 비밀번호로 로그인해주세요.' },
      });
    } catch (err: unknown) {
      const error = err as { response?: { data?: { detail?: string } } };
      setError(error.response?.data?.detail || '비밀번호 재설정에 실패했습니다');
    } finally {
      setIsLoading(false);
    }
  };

  if (!token) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'grey.50',
        }}
      >
        <Container maxWidth="sm">
          <Alert severity="error">
            유효하지 않은 링크입니다. 비밀번호 찾기를 다시 요청해주세요.
          </Alert>
        </Container>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'grey.50',
      }}
    >
      <Container maxWidth="sm">
        <ResetPasswordForm
          onSubmit={handleSubmit}
          isLoading={isLoading}
          error={error}
          token={token}
        />
      </Container>
    </Box>
  );
}
